import { AdminRestriction } from "@safetyculture/s12-apis-connect-web/s12/restrictions/admin/v1/restrictions_pb";

// Descriptions for the "Type" column tooltip on the Restrictions tab
// (restrictions-tab.tsx). Explains each of the 5 shapes the
// AdminRestriction.restriction oneof (@safetyculture/s12-apis-connect-web,
// s12/restrictions/admin/v1/restrictions_pb) can take - the proto itself has
// no description field, so this is hand-authored from the message shapes and
// how they're rendered/edited in restrictions-tab.tsx.
//
// Keyed by the oneof's own `case` union (rather than a bare string) so a new
// restriction shape added to the proto fails the build here instead of
// silently rendering no tooltip.
type RestrictionType = NonNullable<AdminRestriction["restriction"]["case"]>;

export const RESTRICTION_TYPE_DESCRIPTIONS: Readonly<
  Record<RestrictionType, string>
> = {
  feature: "A simple on/off gate for a feature - either restricted or not.",
  quota:
    "A single numeric allowance with a limit, remaining amount, and a reset date.",
  quotaMap:
    "A named collection of independent quota buckets tracked separately under one restriction.",
  timeWindow:
    "A duration-based limit, typically how far back data (e.g. history) is retained or visible.",
  allowList:
    "A capped list of explicitly allowed IDs, with a maximum capacity.",
};
